// Profile banner gradient presets. Keys are validated server-side (routes_social.py BANNER_PRESETS).
export const BANNER_PRESETS = [
  { key: "aurora", label: "Aurora", className: "bg-gradient-to-r from-[#1f6feb] via-[#7c3aed] to-[#3b9eff]" },
  { key: "sunset", label: "Sunset", className: "bg-gradient-to-r from-[#f97316] via-[#ec4899] to-[#a855f7]" },
  { key: "ocean", label: "Ocean", className: "bg-gradient-to-r from-[#0891b2] via-[#0ea5e9] to-[#2563eb]" },
  { key: "forest", label: "Forest", className: "bg-gradient-to-r from-[#16a34a] via-[#10b981] to-[#0d9488]" },
  { key: "ember", label: "Ember", className: "bg-gradient-to-r from-[#dc2626] via-[#f97316] to-[#f59e0b]" },
  { key: "midnight", label: "Midnight", className: "bg-gradient-to-r from-[#1e293b] via-[#4338ca] to-[#6366f1]" },
  { key: "candy", label: "Candy", className: "bg-gradient-to-r from-[#ec4899] via-[#d946ef] to-[#f43f5e]" },
  { key: "gold", label: "Gold", className: "bg-gradient-to-r from-[#f59e0b] via-[#eab308] to-[#fbbf24]" },
];

export function bannerClass(key) {
  return (BANNER_PRESETS.find((b) => b.key === key) || BANNER_PRESETS[0]).className;
}
